import { useChat } from "../../providers/chat-provider";

/**
 * The full (horizontal) logo, shown in place of the symbol and the titles. It carries the brand
 * name already, so it is decorative: the title stays for assistive technologies, as `sr-only`.
 */
export const HeaderFullLogo = () => {
  const { chatbotParams } = useChat();

  return (
    <img
      id="header-full-logo"
      alt=""
      className="min-w-0 max-w-full w-auto object-contain object-left"
      src={chatbotParams.fullLogoDataUri}
      style={{ height: chatbotParams.fullLogoHeight }}
    />
  );
};
